var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivesession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6612 11.3664V4.1443C16.6612 3.84962 16.5442 3.567 16.3358 3.35863C16.1274 3.15026 15.8448 3.0332 15.5501 3.0332H4.43922C4.14454 3.0332 3.86193 3.15026 3.65356 3.35863C3.44519 3.567 3.32812 3.84962 3.32812 4.1443V11.3664H16.6612Z",
    stroke: "#07D3C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.235 14.8049C18.3102 14.9741 18.3419 15.1594 18.3272 15.3439C18.3126 15.5284 18.2521 15.7064 18.1512 15.8616C18.0503 16.0168 17.9122 16.1443 17.7495 16.2326C17.5868 16.3209 17.4046 16.3671 17.2195 16.3671H2.7753C2.59018 16.3671 2.40799 16.3209 2.24528 16.2326C2.08257 16.1443 1.94449 16.0168 1.8436 15.8616C1.7427 15.7064 1.68219 15.5284 1.66754 15.3439C1.6529 15.1594 1.6846 14.9741 1.75976 14.8049L3.33084 11.3672H16.6639L18.235 14.8049Z",
    stroke: "#07D3C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88672 14.1445H11.1089",
    stroke: "#07D3C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivesession);
export default __webpack_public_path__ + "static/media/activesession.aaae1a98901a044d433814e67b5b9e75.svg";
export { ForwardRef as ReactComponent };